import styled from 'styled-components';

export const AppContainer = styled.div`
    height: 100%;
    width: 100%;
`;

export const AppRow = styled.div`
    height: 100%;
    width: 100%;
    margin: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
